import React from 'react';

interface SuggestedChipsProps {
  onChipClick: (question: string) => void;
}

const SUGGESTED_QUESTIONS = [
  "What are Parth's technical skills?",
  "Tell me about his projects",
  "What are his hobbies?",
  "What are his work interests?",
];

const SuggestedChips: React.FC<SuggestedChipsProps> = ({ onChipClick }) => {
  return (
    <div className="mb-4 animate-fade-in">
      <p className="text-xs font-mono text-dev-text-dimmed mb-2 px-1">Suggested questions:</p>
      <div className="flex flex-wrap gap-2">
        {SUGGESTED_QUESTIONS.map((question, index) => (
          <button
            key={index}
            onClick={() => onChipClick(question)}
            className="text-xs font-mono px-3 py-1.5 rounded-full bg-dev-bg-light border border-dev-border text-dev-text-muted hover:border-dev-accent hover:text-dev-accent transition-all duration-200"
          >
            {question}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestedChips;
